import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { getTrans } from 'modules/i18n';

interface DeleteLanguageSkillModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteLanguageSkillModal({
  isOpen,
  onClose,
  onConfirm
}: DeleteLanguageSkillModalProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} data-testid="delete-modal">
      <DialogTitle>{getTrans('modal.deleteLanguageSkill.title')}</DialogTitle>
      <DialogContent>
        {getTrans('modal.deleteLanguageSkill.body')}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {getTrans('general.cancel')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {getTrans('general.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
